import { NavLink } from '@tov-plus/frontend-data';
import { StatePanel } from '../components/StatePanel';
import { msg } from '@tov-plus/ui';
export function NotFoundPage() {
  return (
    <main className="guest-standalone" data-testid="guest-route-not-found">
      <StatePanel
        preset="not-found"
        actions={
          <NavLink className="primary-button" to="/">
            {msg(
              'pages.not_found_page.pages_not_found_page_return_to_the_guest_overview',
            )}{' '}
          </NavLink>
        }
      />
    </main>
  );
}
